import { render, staticRenderFns } from "./BookingSpacePage.vue?vue&type=template&id=a04345f4&scoped=true"
import script from "./BookingSpacePage.vue?vue&type=script&lang=js"
export * from "./BookingSpacePage.vue?vue&type=script&lang=js"
import style0 from "./BookingSpacePage.vue?vue&type=style&index=0&id=a04345f4&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04345f4",
  null
  
)

export default component.exports